import * as React from "react";

import { AppContext } from "@1js/acui-context";
import {
  isResponsiveRibbonScalingMLRFeatureEnabled,
  isResponsiveRibbonScalingSLRFeatureEnabled,
} from "@1js/acui-experiments";

export const useResponsiveRenderingIsEnabled = () => {
  const context = React.useContext(AppContext);

  if (!context || !context.isExperimentalFeatureEnabled) {
    return false;
  }

  return (
    isResponsiveRibbonScalingSLRFeatureEnabled(
      context.isExperimentalFeatureEnabled
    ) ||
    isResponsiveRibbonScalingMLRFeatureEnabled(
      context.isExperimentalFeatureEnabled
    )
  );
};
